import { useKeyboardEvents as r } from "../../../hooks/useKeyboardEvents.js";
const E = ({
  ref: o,
  onClick: e,
  onIconAction: t,
  disabled: n
}) => {
  r({
    ref: o,
    onEnter: () => {
      !n && e && e(new MouseEvent("click"));
    },
    onBackspace: () => {
      !n && t && t(new MouseEvent("click"));
    }
  });
};
export {
  E as useChipKeyboardEvent
};
